<template>
  <div>
    <b-message type="is-primary">
      {{ $t("brandingExplained") }}
    </b-message>
    <BrandingResults v-if="false" />
    <b-field :label="$t('brandingPreview')" class="mt-5">
      <BrandingPreview
        :branding="{
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          tertiaryColor: tertiaryColor,
          fourthColor: fourthColor,
          logoSrc: logoSrc,
        }"
      />
    </b-field>
    <b-field grouped group-multiline>
      <b-field :label="$t('primaryColor')">
        <chrome-picker v-model="primaryColor" :disable-alpha="true" />
      </b-field>
      <b-field :label="$t('secondaryColor')">
        <chrome-picker v-model="secondaryColor" :disable-alpha="true" />
      </b-field>
      <b-field :label="$t('tertiaryColor')">
        <chrome-picker v-model="tertiaryColor" :disable-alpha="true" />
      </b-field>
      <b-field :label="$t('fourthColor')">
        <chrome-picker v-model="fourthColor" :disable-alpha="true" />
      </b-field>
    </b-field>
    <b-field group-multiline grouped>
      <b-field class="mt-4" :label="$t('logoUpload')">
        <div style="max-width: 383px" class="card mb-4">
          <div v-if="!logoSrc">
            <b-upload v-model="logoFile" drag-drop>
              <section class="section card-content">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large" />
                  </p>
                  <p>{{ $t("logoUploadInstructions") }}</p>
                  <p>{{ $t("allowedLogoFormat") }}</p>
                </div>
              </section>
            </b-upload>
            <div class="mt-2 pb-2 content has-text-centered">
              <b-button
                @click="
                  logoSrc = '/assets/qondalogo.svg';
                  uploadImage();
                "
              >
                {{ $t("reset") }}
              </b-button>
            </div>
          </div>
          <div v-else class="card-content content">
            <b-progress :type="progress == 100 ? 'is-success' : ''" :value="progress" />
            <figure class="image">
              <img :src="logoSrc" class="" style="max-width: 300px" />
            </figure>
            <b-field class="has-text-centered">
              <b-button
                class="is-danger"
                @click="
                  logoFile = null;
                  logoSrc = null;
                  progress = 0;
                "
              >
                {{ $t("delete") }}
              </b-button>
            </b-field>
          </div>
        </div>
      </b-field>
      <b-field class="mt-4" :label="$t('selectSurvey')">
        <div class="card mb-4">
          <SurveyChooser />
        </div>
      </b-field>
    </b-field>
    <b-button type="is-warning" @click="resetBranding">
      {{ $t("resetBrandingToOrgColors") }}
    </b-button>
  </div>
</template>

<script>
import { storage } from "@/firebase";
import { Chrome } from "vue-color";
import cloneDeep from "clone-deep";
import BrandingResults from "./BrandingResults";
import SurveyChooser from "./SurveyChooser";
import BrandingPreview from "@/components/BrandingPreview";

export default {
  name: "Branding",
  components: {
    "chrome-picker": Chrome,
    BrandingResults,
    SurveyChooser,
    BrandingPreview,
  },
  data() {
    return {
      logoFile: null,
      progress: 0,
    };
  },
  computed: {
    logoSrc: {
      get() {
        return this.branding.brandLogo;
      },
      set(src) {
        this.branding.brandLogo = src;
      },
    },
    primaryColor: {
      get() {
        return this.branding.primaryColor;
      },
      set(color) {
        this.branding.primaryColor = color.hex;
      },
    },
    secondaryColor: {
      get() {
        return this.branding.secondaryColor;
      },
      set(color) {
        this.branding.secondaryColor = color.hex;
      },
    },
    tertiaryColor: {
      get() {
        return this.branding.tertiaryColor;
      },
      set(color) {
        this.branding.tertiaryColor = color.hex;
      },
    },
    fourthColor: {
      get() {
        return this.branding.fourthColor;
      },
      set(color) {
        this.branding.fourthColor = color.hex;
      },
    },
    branding: {
      get() {
        return this.$store.state.draft.branding;
      },
      set(value) {
        this.$store.commit("SET_DRAFT_FIELD", ["branding", value]);
      },
    },
  },
  watch: {
    async logoFile(file) {
      if (!file) {
        // onDelete do nothing
        return;
      }

      if (file.type.substring(0, 5) !== "image" || file.type == "image/tiff") {
        // check if image
        this.logoSrc = null;
        this.$buefy.toast.open({
          message: this.$t("noImageType"),
          type: "is-danger",
        });
        return;
      }

      let self = this;
      let reader = new FileReader();
      reader.onload = function (event) {
        self.logoSrc = event.target.result;
        self.uploadImage();
      };

      reader.readAsDataURL(file);
    },
  },
  created() {
    this.branding = cloneDeep(this.$store.state.branding);
    // quick fix for organizations which do not yet have 3./4. colors
    if (!this.branding.tertiaryColor) {
      this.branding.tertiaryColor = "#ffffff";
    }
    if (!this.branding.fourthColor) {
      this.branding.fourthColor = "#ffffff";
    }
  },
  methods: {
    async uploadImage() {
      console.log(this.logoFile);
      if (this.logoFile !== null) {
        let ref = storage
          .refFromURL("gs://travio-icons/")
          .child(
            `organizations/${this.$store.getters.getOrganizationId}/events/${this.$route.params.eventId}/${this.logoFile.name}`,
          );
        let uploadTask = ref.put(this.logoFile);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            this.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          (error) => {
            console.log(error);
            this.$buefy.toast.open({
              message: this.$t("imageUploadFailed"),
              type: "is-danger",
            });
            this.logoFile = null;
            this.logoSrc = null;
            this.progress = 0;
          },
        );
        this.branding.brandLogo = await uploadTask.then(async (snapshot) => {
          return await snapshot.ref.getDownloadURL();
        });
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("imageUploaded"),
        });
      } else {
        this.progress = 100;
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("imageUploaded"),
        });
      }
      try {
        await this.$store.dispatch("saveBrandingDraft", this.$route.params.eventId);
      } catch (error) {
        console.log(error);
      }
    },
    async resetBranding() {
      this.branding = cloneDeep(this.$store.state.branding);
      this.uploadImage();
    },
  },
};
</script>

<style></style>
